import React from 'react';
import styled from '@emotion/styled';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import { TextInputField } from '../../../components/FormCom/FormField';
import { FormSubmitButton } from '../../../components/Button/FormSubmitButton';
import { JoinWaitlistDataType, joinWaitlistInitialValues, JoinWaitlistSchema } from '../../../models/trackPage/joinWaitlist.model';

const Hero = () => {
  const onSubmit = async (values: JoinWaitlistDataType) => {
    console.log(values);
  };
  return (
    <Container>
      <WrapImage
        className='web'
        src='/static/img/cml/partner_hero_bg.png'
        alt='hero image'
      />
      <WrapImage
        className='mobile'
        src='/static/img/cml/partner_hero_bg.png'
        alt='hero image'
      />
      <FormArea>
        <FormAreaWrapper>
          <TextHeader className='text-content'>
            <H1>
              We are looking to build <br />
              <Span>valuable partnerships</Span>
            </H1>
            <Descriptions>
              At CML, we are looking to collaborate with warehousing and dispatch companies throughout Nigeria. If you are interested, sign up and our team will follow up
            </Descriptions>
          </TextHeader>
          <WaitlistFormPlace>
            <FormComponent
              initialValues={joinWaitlistInitialValues}
              schema={JoinWaitlistSchema}
              onSubmit={onSubmit}
              className='smaller-inline'
            >
              <TextInputField
                label=''
                name='email'
                id='email'
                type='email'
                placeholder='Enter email address'
              />
              <FormSubmitButton loading={false}>Join The Waitlist</FormSubmitButton>
            </FormComponent>
          </WaitlistFormPlace>
        </FormAreaWrapper>
      </FormArea>
    </Container >
  );
};

export default Hero;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -1rem -5.4375rem 0;
  padding: 3rem 5.4375rem;
  position: relative;
  overflow: hidden;

  width: 100vw;
  min-height: calc(100vh - 80px);

  @media (max-width: 884px) {
    padding: 0;
    margin: 0 -24px;
    min-height: calc(100vh - 60px);
  }
`;

const WrapImage = styled.img`
  object-fit: cover;
  position: absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;

  &.mobile {
    display: none;
  }

  @media (max-width: 884px) {
    &.web {
      display: none;
    }

    &.mobile {
      display: block;
      object-fit: cover;
      object-position: center center;
    }
  }

  @media (max-width: 480px) {
    &.mobile {
      display: block;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
`;

const FormArea = styled.div`
  display: grid;
  max-width: 730px;
  // padding: 0 5.4375rem;
  z-index: 200;
  height: 100%;

  @media (max-width: 884px) {
    place-content: center;
    padding: 0 24px;
  }

  @media (max-width: 480px) {
    padding: 0;
    margin: auto;
  }
`;

const FormAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 28px;

  @media (max-width: 884px) {
    display: flex;
    width: 440px;
    height: fit-content;
  }

  @media (max-width: 480px) {
    width: 90vw;
  }

  & > .text-content {
    animation-name: slide-in;
    animation-duration: 0.4s;
    animation-timing-function: ease-in-out;

    @keyframes slide-in {
      from {
        transform: translateX(-100%);
      }
      to {
        transform: none;
      }
    }
  }
`;

const TextHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const H1 = styled.h1`
  font-size: 60px;
  font-weight: 800;
  line-height: 78px;
  text-align: center;

  @media (max-width: 884px) {
    font-size: 44px;
    line-height: 57px;
  }

  @media (max-width: 320px) {
    font-size: 32px;
    line-height: 36px;
  }
`;

const Span = styled.span`
  color: ${({ theme }) => theme.palette.redFontColor};
`;

const Descriptions = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  max-width: 600px;

  @media (max-width: 320px) {
    font-size: 16px;
    line-height: 18px;
  }
`;

const WaitlistFormPlace = styled.div`
  & > * > div,
  & > * > button {
    animation-name: popup;
    animation-duration: 0.7s;
    animation-fill-mode: both;
  }

  & > * > button {
    animation-delay: 0.2s;
    animation-timing-function: ease-in-out;
  }

  @keyframes popup {
    from {
      transform: translateY(50%);
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    70% {
      opacity: 0.7;
    }
    to {
      transform: none;
      opacity: 1;
    }
  }

  form {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;

    div {
      width: 100% !important;
    }
      button {
        margin:0 !important;
      }
`;

